import { useSearchParams } from 'react-router-dom';

import { usePrerenderUserId } from '../../hooks/usePrerenderUser';
import { readRememberedDomain } from './cfResumeDomainStore';

export const useCfResumeDomain = (enabled: boolean): string | null => {
  const [searchParams] = useSearchParams();
  const userId = usePrerenderUserId();

  if (!enabled) return null;

  return searchParams.get('domain') || readRememberedDomain(userId);
};
